import initialState from './initialState';
import * as types from '../constants/actionTypes';
import * as messageUtils from '../../redhotpie-shared-lib/functions/messageUtils';

export default (state = initialState.publicLiveStreamsReducer, action) => {
  const { payload } = action;

  switch (action.type) {
    case types.GET_PUBLIC_LIVE_STREAMS_REQUEST:
      return state.set('isHasMore', false).set('isLoading', true).set('isAPIDataLoaded', false).set('behavior', 'get');

    case types.GET_PUBLIC_LIVE_STREAMS_FAILURE:
      return state.set('isLoading', false).set('isAPIDataLoaded', true).set('isError', true);

    case types.GET_PUBLIC_LIVE_STREAMS_SUCCESS:
      const newItems = payload.items;
      state = state.set('items', newItems);
      return state
        .set('filter', { ...state.filter, ...payload.filter })
        .set('isHasMore', payload.isHasMore)
        .set('isLoading', false)
        .set('isAPIDataLoaded', true)
        .set('isError', false);

    case types.GET_MORE_PUBLIC_LIVE_STREAMS_SUCCESS:
      return state
        .set('filter', { ...state.filter, ...payload.filter })
        .set('isHasMore', payload.isHasMore)
        .set('isLoading', false)
        .set('isError', false)
        .set('items', [...state.items, ...payload.items]); // if load more, just concat new and old items together
    case types.CHANGE_PUBLIC_LIVE_STREAMS_FILTERED:
      return state.set('isFiltered', payload.isFiltered);
    case types.CREATE_PUBLIC_LIVE_STREAM_SUCCESS:
      const items = [...state.items];
      items.push(action.data);
      state = state.set('items', items);
      return state;
    case types.SELECT_PUBLIC_LIVE_STREAM_SUCCESS:
      const roomSelected = state.items.filter(room => {
        return room.roomJid === action.data.roomJid;
      });
      if (roomSelected.length > 0) {
        return state.set('selectedLiveStreamRoom', roomSelected[0]);
      }
      return state.set('waitingProgress', false);
    case types.QUIT_PUBLIC_LIVE_STREAM_SUCCESS:
      return state.set('selectedLiveStreamRoom', initialState.publicLiveStreamsReducer.selectedLiveStreamRoom).set('waitingProgress', false);

    case types.GET_PUBLIC_STREAM_DETAIL_SUCCESS:
      const listViewer = action.data.filter((value, index, self) => {
        return self.lastIndexOf(value) === index;
      });
      return state.setIn(['selectedLiveStreamRoom', 'listViewer'], listViewer);

    case types.GET_LIST_VIEWERS_STATUS_SUCCESS:
      const { members } = action;
      const data = [];
      members.forEach(m => {
        let user = Object.assign({}, { name: m });
        action.data.forEach(u => {
          // messageUtils.addPrefixAndSuffix(user.name);
          if (messageUtils.addPrefixAndSuffix(user.name) === u.userJid) {
            user = Object.assign({}, user, { status: u.status });
          }
        });
        data.push(user);
      });

      return state.setIn(['selectedLiveStreamRoom', 'members'], data);

    case types.UPDATE_USER_STATUS_LIVE_SUCCESS:
      const users = [...state.selectedLiveStreamRoom.members];
      const member = [];
      users.forEach(m => {
        let user = Object.assign({}, m);
        if (action.data.userId.toString() === m.name.toString()) {
          user = Object.assign(user, { status: parseInt(action.data.status) });
        }
        member.push(user);
      });
      return state.setIn(['selectedLiveStreamRoom', 'members'], member);

    case types.USER_LOGOUT_SUCCESS:
      return initialState.publicLiveStreamsReducer;
    case types.SHOW_ALERT_STOPPED_PUBLIC_STREAM_DETAIL_SUCCESS:
      return state.set('isShowAlertStoppedPublicLiveStream', action.data);
    case types.SET_WAITING_PROGRESS_PUBLIC_LIVE_STREAM_SUCCESS:
      return state.set('waitingProgress', action.data);

    default:
      return state;
  }
};
